var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 13.918a1.23 1.23 0 01-.345.854l-4.925 5.104a.419.419 0 01-.287.131.442.442 0 01-.183-.026.46.46 0 01-.262-.392V17h-1.691a1.251 1.251 0 01-.994-.47 1.335 1.335 0 01-.313-.836V12h-1.495a.5.5 0 01-.472-.666l1.88-3.993a.5.5 0 01.467-.323h8.12a.5.5 0 01.5.5zM12.375 15a.625.625 0 00-.625.625v3a.625.625 0 00-1.25 0v1a.625.625 0 00-1.25 0v1a.625.625 0 00-1.25 0v2.8a.51.51 0 00.167.392.604.604 0 00.444.183h1.64a.586.586 0 00.416-.156l2.11-1.751a.437.437 0 00.11-.131.534.534 0 00.113-.314v-6.023a.625.625 0 00-.625-.625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.955 3a13 13 0 11-13 13 13 13 0 0113-13m0-1a14 14 0 1014 14 14 14 0 00-14-14z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--quiet-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'QuietCircleIcon';
export default Icon;